import CollectionsPage from './CollectionsPage.container'
export default CollectionsPage
